export default __webpack_public_path__ + "static/media/sampleCSV.77356360.csv";